var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamaraOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7889 3.53147H20.7486L20.3634 2.26253C19.9992 1.0634 18.9129 0.257812 17.6602 0.257812H10.8673C9.61419 0.257812 8.5275 1.0634 8.16376 2.26253L7.77851 3.53147H6.21149C2.78653 3.53147 0 6.318 0 9.74333V17.532C0 20.957 2.78653 23.7435 6.21149 23.7435H21.7885C25.2135 23.7435 28 20.957 28 17.532V9.74333C28.0004 6.318 25.2138 3.53147 21.7889 3.53147ZM25.7364 17.5317C25.7364 19.7084 23.9657 21.4792 21.7889 21.4792H6.21149C4.03471 21.4788 2.26394 19.7081 2.26394 17.5317V9.74333C2.26394 7.56656 4.03471 5.79578 6.21149 5.79578H9.4576L10.3303 2.9202C10.4028 2.68211 10.6186 2.52213 10.8673 2.52213H17.6602C17.9089 2.52213 18.1243 2.68211 18.1972 2.92096L19.0703 5.79578H21.7885C23.9653 5.79578 25.7361 7.56656 25.7361 9.74333L25.7364 17.5317Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0469 7.58789C10.7098 7.58789 7.99463 10.3027 7.99463 13.6401C7.99463 16.9772 10.7095 19.692 14.0469 19.692C17.3843 19.692 20.0995 16.9772 20.0995 13.6401C20.0995 10.3027 17.3843 7.58789 14.0469 7.58789ZM14.0469 17.4285C11.958 17.4285 10.2586 15.729 10.2586 13.6405C10.2586 11.5517 11.958 9.85221 14.0469 9.85221C16.1361 9.85221 17.8356 11.5517 17.8356 13.6405C17.8356 15.729 16.1361 17.4285 14.0469 17.4285Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamaraOutlineIcon);
export default __webpack_public_path__ + "static/media/camara_outline_icon.3d160443a677932a5215c6d7ee742efe.svg";
export { ForwardRef as ReactComponent };